import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import OrderPayment from "@/model/OrderPayment";
import { Formatter } from "@/util/Formatter";
import { useI18n } from "vue-i18n";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderPaymentsListRow',
    props: {
        payment: { type: OrderPayment, required: true }
    },
    setup(__props) {
        const { t } = useI18n();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("tr", null, [
                _createElementVNode("td", null, _toDisplayString(__props.payment.date), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(Formatter).currency(__props.payment.amount)), 1),
                _createElementVNode("td", null, _toDisplayString(__props.payment.paymentMethod), 1),
                _createElementVNode("td", null, _toDisplayString(__props.payment.status ? _unref(t)(__props.payment.status) : ''), 1)
            ]));
        };
    }
});
